
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.993 14V7.828a2 2 0 00-.586-1.414l-2.828-2.828A2.003 2.003 0 0016.164 3H5.007a2 2 0 00-2 2.015l.104 14a2 2 0 002 1.985H13","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.993 3v3.909a1 1 0 01-1 1h-6a1 1 0 01-1-1V3M7 21v-7.714C7 12.576 7.576 12 8.286 12h7.429c.709 0 1.285.576 1.285 1.286V14M21 18l-3 3-2-2","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    